module.exports = __webpack_public_path__ + "img/recharge-guide.9c695f2.png";